import { render, staticRenderFns } from "./NoRights.vue?vue&type=template&id=58ce6088&scoped=true&"
import script from "./NoRights.vue?vue&type=script&lang=js&"
export * from "./NoRights.vue?vue&type=script&lang=js&"
import style0 from "./NoRights.vue?vue&type=style&index=0&id=58ce6088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ce6088",
  null
  
)

export default component.exports